import React from "react"
import { Input, Icon } from "semantic-ui-react"
import "./BarreDeRecherche.css"

const BarreDeRecherche = ({ prestations, style, onSearchChange, searchValue }) => (
  <Input
    id="BarSearch"
    icon={<Icon id="loupe" name="search" link />}
    iconPosition="left"
    placeholder={prestations}
    style={style}
    onChange={onSearchChange}
    value={searchValue}
    fluid
  />
)

export default BarreDeRecherche



// WEBPACK FOOTER //
// ./src/components/Pro/Entete/BarreDeRecherche.js